__turbopack_context__.v({
  "productVariants": "product-variants-module-scss-module__Vj12Sq__productVariants",
  "productVariantsTitle": "product-variants-module-scss-module__Vj12Sq__productVariantsTitle",
  "productVariantsWrap": "product-variants-module-scss-module__Vj12Sq__productVariantsWrap",
  "variantBlock": "product-variants-module-scss-module__Vj12Sq__variantBlock",
});
